import type React from 'react';

import { UnauthenticatedRouter } from '../routers/UnauthenticatedRouter';

export const UnauthenticatedLayout: React.FC = () => {
  return <UnauthenticatedRouter />;
};
